import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import CancelIcon from '@mui/icons-material/Cancel';
import type { SvgIconComponent } from '@mui/icons-material';
import {
  GoalStatus,
  MilestoneStatus,
  getGoalStatusLabel,
  getGoalStatusColor
} from '../circles-page/constants';

export { GoalStatus, MilestoneStatus, getGoalStatusLabel, getGoalStatusColor };

export enum GoalType {
  Learning = 0,
  Performance = 1
}

export function getGoalTypeLabel(type: GoalType): string {
  switch (type) {
    case GoalType.Learning:
      return 'Learning';
    case GoalType.Performance:
      return 'Performance';
    default:
      return 'Learning';
  }
}

export function getGoalTypeColor(type: GoalType): 'primary' | 'secondary' {
  switch (type) {
    case GoalType.Performance:
      return 'secondary';
    default:
      return 'primary';
  }
}

/**
 * Get MUI color for milestone status
 */
export function getMilestoneStatusColor(
  status: MilestoneStatus
): 'success' | 'primary' | 'warning' | 'error' {
  switch (status) {
    case MilestoneStatus.Completed:
      return 'success';
    case MilestoneStatus.InProgress:
      return 'primary';
    case MilestoneStatus.NotStarted:
      return 'warning';
    case MilestoneStatus.Cancelled:
      return 'error';
    default:
      return 'warning';
  }
}

/**
 * Get icon component for goal status
 */
export function getGoalStatusIcon(status: GoalStatus): SvgIconComponent {
  switch (status) {
    case GoalStatus.NotStarted:
      return PauseIcon;
    case GoalStatus.InProgress:
      return PlayArrowIcon;
    case GoalStatus.Completed:
      return CheckCircleIcon;
    case GoalStatus.Cancelled:
      return CancelIcon;
    default:
      return PauseIcon;
  }
}

/**
 * All available goal statuses for selection
 */
export const GOAL_STATUS_OPTIONS = [
  { value: GoalStatus.NotStarted, label: getGoalStatusLabel(GoalStatus.NotStarted) },
  { value: GoalStatus.InProgress, label: getGoalStatusLabel(GoalStatus.InProgress) },
  { value: GoalStatus.Completed, label: getGoalStatusLabel(GoalStatus.Completed) },
  { value: GoalStatus.Cancelled, label: getGoalStatusLabel(GoalStatus.Cancelled) }
];
